export default function formatNumberToTwoDigitsMinimum(number: number) {
  return number <= 9 ? '0' + number : number.toString();
}
